import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/ktx/transplantation-screening/cardiology/bloodPressure";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	bloodPressure: {
		id: "ktx.blood_pressure.title",
		defaultMessage: "Vérnyomás"
	},
	systolicBloodPressure: {
		id: "ktx.blood_pressure.field.systolic",
		defaultMessage: "Szisztolés vérnyomás"
	},
	diastolicBloodPressure: {
		id: "ktx.blood_pressure.field.diastolic",
		defaultMessage: "Diasztolés vérnyomás"
	},
	heartRate: {
		id: "ktx.blood_pressure.field.heart_rate",
		defaultMessage: "Szívfrekvencia"
	}
});

const fields: {
	[key: string]: FieldData;
} = {
	systolicBloodPressure: {
		type: "field",
		path: ["systolicBloodPressure"],
		label: messages.systolicBloodPressure,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	diastolicBloodPressure: {
		type: "field",
		path: ["diastolicBloodPressure"],
		label: messages.diastolicBloodPressure,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	heartRate: {
		type: "field",
		path: ["heartRate"],
		label: messages.heartRate,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{ width: 4, field: fields.systolicBloodPressure },
				{ width: 4, field: fields.diastolicBloodPressure },
				{ width: 4, field: fields.heartRate }
			]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_bloodPressure",
	value: {
		schemaId: "bloodPressure",
		title: messages.bloodPressure,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
